<template>
  
    <ContactsDuplicatesSubmit
      v-if="contacts_duplicates_step === 'form_submit'"
      :contacts_duplicates_list="contacts_duplicates_list"
      :contacts_view="contacts_view"
      :contacts_selection="contacts_selection"
      @contactsDuplicatesSubmitClose="onContactsDuplicatesList"
      @contactsDuplicatesSubmit="onContactsDuplicatesListClose">
    </ContactsDuplicatesSubmit>

    <ContactsDuplicatesListSection
      v-else-if="contacts_duplicates_step === 'list'"
      :contacts_duplicates_list="contacts_duplicates_list"
      :contacts_view="contacts_view"
      :contacts_selection="contacts_selection"
      @contactsDuplicatesListClose="onContactsDuplicatesListClose"
      @contactsDuplicatesSubmit="onContactsDuplicateSubmit">
    </ContactsDuplicatesListSection>

    <ContactsDuplicatesOptionsSection
      v-else
      :contacts_duplicates_list="contacts_duplicates_list"
      :contacts_selection="contacts_selection"
      @contactsDuplicatesList="onContactsDuplicatesList">
    </ContactsDuplicatesOptionsSection>
</template>

<script setup>
  import {ref, reactive, onBeforeMount}   from 'vue';
  import ContactsController               from '@/js/Contacts/ContactsController';
  import ContactsDuplicatesCollection     from '@/js/Contacts/Collections/ContactsDuplicatesCollection';
  import ContactsDuplicatesListSection    from './Sections/ContactsDuplicatesListSection.vue';
  import ContactsDuplicatesOptionsSection from './Sections/ContactsDuplicatesOptionsSection.vue';
  import ContactsSelectionCollection from '@/js/Contacts/Collections/ContactsSelectionCollection';
  import ContactsDuplicatesSubmit from './Sections/ContactsDuplicatesSubmit.vue';

  const props = defineProps({
    contacts_view: {}
  });

  const contacts_controller       = ContactsController;
  const contacts_selection        = reactive(new ContactsSelectionCollection());
  const contacts_duplicates_list  = reactive(new ContactsDuplicatesCollection());
  const contacts_duplicates_step  = ref('options');

  onBeforeMount(() => {
    contacts_controller.state.on('fetch_foreground', 'success', onLoad);
  });

  const onLoad = () => {
    contacts_duplicates_list.setContactsList(contacts_controller.contacts.persons);
    contacts_duplicates_list.findDuplicates();
  }

  const onContactsDuplicatesList = (email) => {
    setContactSelected(email);
    setContactsDuplicateStep('list');
  }

  const onContactsDuplicateSubmit = () => {
    setContactsDuplicateStep('form_submit');
  }

  const onContactsDuplicatesListClose = () => {
    setContactsDuplicateStep('options');
  }

  const setContactSelected = (email) => {
    contacts_duplicates_list.email_selected = email;
  }

  const setContactsDuplicateStep = (value) => {
    contacts_duplicates_step.value = value;
  }
</script>